import baseAPI from "@/http";

const router = "api/ec2-codex";

export const ec2CodexAPI = {
  status: () => baseAPI.get(`${router}/status`),
  start: () => baseAPI.post(`${router}/start`),
  stop: () => baseAPI.post(`${router}/stop`),
  allowRdp: () => baseAPI.post(`${router}/allow-rdp`),
  downloadRdp: () => baseAPI.get(`${router}/rdp`, { responseType: "blob" }),
};
